var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "122.88px",
    height: "122.88px",
    viewBox: "0 0 122.88 122.88",
    enableBackground: "new 0 0 122.88 122.88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.438,0C95.37,0,122.88,27.51,122.88,61.441S95.37,122.88,61.438,122.88 C27.509,122.88,0,95.373,0,61.441S27.509,0,61.438,0L61.438,0z M61.438,18.382c23.781,0,43.06,19.278,43.06,43.06 s-19.278,43.057-43.06,43.057c-23.779,0-43.057-19.275-43.057-43.057S37.66,18.382,61.438,18.382L61.438,18.382z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLineIcon);
export default __webpack_public_path__ + "static/media/circle-line-icon.0528fc12f4b0be4b68273c02dcc17fdf.svg";
export { ForwardRef as ReactComponent };